import React from "react";
import { Route, Switch } from "react-router-dom";
// import { Route, Redirect, Switch } from "react-router-dom";
import RouteApplied from "./components/RouteApplied";
import RouteAuthenticated from "./components/RouteAuthenticated";
import RouteUnauthenticated from "./components/RouteUnauthenticated";
import Home from "./containers/Home";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import NewNote from "./containers/NewNote";
import Notes from "./containers/Notes";
import Contacts from "./containers/Contacts";
import Events from "./containers/Events";
import Timeline from "./containers/Timeline";
import Settings from "./containers/settings/Settings";

import NotFound from "./containers/NotFound";


export default ({ childProps }) =>
  <Switch>
    <RouteApplied path="/" exact component={Home} props={childProps} />
    <RouteApplied path="/Home" exact component={Home} props={childProps} />
    <RouteUnauthenticated path="/login" exact component={Login} props={childProps} />
    <RouteUnauthenticated path="/signup" exact component={Signup} props={childProps} />
    <RouteAuthenticated path="/logout" exact component={Home} props={childProps} />
    <RouteAuthenticated path="/contacts" exact component={Contacts} props={childProps} />
    <RouteAuthenticated path="/events" exact component={Events} props={childProps} />
    <RouteAuthenticated path="/timeline/:contactId" exact component={Timeline} props={childProps} />
    <RouteAuthenticated path="/timeline" exact component={Timeline} props={childProps} />
    <RouteAuthenticated path="/notes/new" exact component={NewNote} props={childProps} />
    <RouteAuthenticated path="/notes/:id" exact component={Notes} props={childProps} />
    <RouteAuthenticated path="/settings" exact component={Settings} props={childProps} />
    {/* <RouteAuthenticated path="/settings/SetupGmail" exact component={SetupGmail} props={childProps} /> */}


    {/* <Route path="/googleacf6ed510e058f8e.html" exact component={<Redirect to='/googleacf6ed510e058f8e.html'/>}/> */}
    <Route path="/googleacf6ed510e058f8e.html" exact Redirect to='/googleacf6ed510e058f8e.html'/>

    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js